import type { FaireProductEntity } from "../../entity_types/product";

export const p_zgtptmf6u6: FaireProductEntity = {
  token: "p_zgtptmf6u6",
  type: "product",
  name: "Green Bandana Zip Sweater",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/a9b45a59b7ce567866c435f77c7195854a0dc386de053649815f65694d5b835f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/91093dfabfd6e5f8f22c64dad6f887656a0875659580ae7225d334849994c31d.jpeg",
    "https://cdn.faire.com/fastly/3bb807b96f6ce2e042a7fa25553fb3d47250f09abf5765c867bc8d1e53a0d2f6.jpeg",
    "https://cdn.faire.com/fastly/c2906160e75141934581c583da49f2f962a208a550cab78430bffc3f4bbc0fa6.jpeg",
    "https://cdn.faire.com/fastly/bd6bda94e14c3ede0443ca490a38f8ab7ce12492f84769161dfebf68f384e732.jpeg"
  ],
  priceDollars: 33.95,
  description: "Green Bandana Zip Sweater featuring an allover black bandana-inspired pattern, designed with a classic collar, front zip closure, two front pockets, long sleeves, and a relaxed fit in a soft knit fabric for casual everyday wear or layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:54.877Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
